import {
  MdClose,
  MdContentCopy,
  MdContentPaste,
  MdPlaylistAdd,
  MdRemove,
} from '@teamworksdev/icons';
import { ReactNode } from 'react';
import {
  ContextMenuGroup,
  ContextMenuItem,
  ContextMenuSeparator,
} from '../../../../components/context-menu/context-menu';
import { SchemeFormMutationFns, SchemeFormSelectionData } from '../types';

export function getContextMenuContent(
  data: readonly SchemeFormSelectionData[],
  mutationFns: SchemeFormMutationFns,
): ReactNode {
  const pattern = processDataForContextMenu(data);

  if (!pattern) {
    return <CopyPasteContextMenuGroup />;
  }

  if (pattern.type === 'manySets') {
    return <CopyPasteContextMenuGroup />;
  }

  return (
    <>
      <AddSetContextMenuItem onAddSet={() => mutationFns.onAddSet()} />

      <ContextMenuItem
        onSelect={() => mutationFns.onRemoveSet(pattern.data.set.id)}
      >
        <MdRemove className="mr-2" size={20} />
        Remove Set
      </ContextMenuItem>

      <ContextMenuSeparator />

      <CopyPasteContextMenuGroup />
    </>
  );
}

const CopyPasteContextMenuGroup = () => {
  return (
    <ContextMenuGroup>
      <ContextMenuItem disabled>
        <MdContentCopy className="mr-2" size={20} />
        Copy
      </ContextMenuItem>
      <ContextMenuItem disabled>
        <MdContentPaste className="mr-2" size={20} />
        Paste
      </ContextMenuItem>
      <ContextMenuItem disabled>
        <MdClose className="mr-2" size={20} />
        Clear
      </ContextMenuItem>
    </ContextMenuGroup>
  );
};

const AddSetContextMenuItem = ({ onAddSet }: { onAddSet: () => void }) => {
  return (
    <ContextMenuItem onSelect={onAddSet}>
      <MdPlaylistAdd className="mr-2" size={20} />
      Add Set
    </ContextMenuItem>
  );
};

type ContextMenuPattern =
  | {
      type: 'one';
      data: SchemeFormSelectionData;
    }
  | {
      type: 'manySets';
      sets: readonly SchemeFormSelectionData[];
    };

function processDataForContextMenu(
  data: readonly SchemeFormSelectionData[],
): ContextMenuPattern | null {
  if (data.length === 0) {
    return null;
  }

  if (data.length === 1 && data[0]) {
    return {
      type: 'one',
      data: data[0],
    };
  }

  return {
    type: 'manySets',
    sets: data,
  };
}
